module.exports = __webpack_public_path__ + "static/media/RTF.f6364e57.svg";